module.exports = __webpack_public_path__ + "static/media/burger.35bcd067.png";